import { getPinFromEmail } from '../../utils/redshif-data-api.js';

var response = {};

async function rememberPin(email, userId) {
    const userPin = await getPinFromEmail(email, userId);

    if (userPin.length === 0) {
        response.success = false;
        response.message = 'Email no encontrado';
    }
    if (userPin.length === 1) {
        const pin = userPin[0].pin;
        const data = {
            email: email,
            pin: pin,
        };
        const url = 'https://cloud.mc.realbetisbalompie.es/rememberPin';
        const journey = await fetch(url, {
            method: 'POST',
            body: JSON.stringify(data),
            headers: {
                'Content-type': 'application/json; charset=UTF-8',
            },
        });

        const journeyResponse = await journey.json();

        if (journeyResponse.success === true) {
            response.success = true;
            response.message = 'Email enviado';
        } else {
            response.success = false;
            response.message = 'Fallo en el envío';
        }
    }
    return response;
}

export { rememberPin };